<template>
  <ListingBlock
    v-if="view.dataLength"
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 3)"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'

defineProps<{
  view: ListView
}>()
</script>
